import React from 'react';
import Icon from '@atlaskit/icon';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import flagDisabledIconUrl from './assets/flag-disabled.svg';
import flagEnabledIconUrl from './assets/flag-enabled.svg';
import messages from './messages.tsx';

interface FlagIconProps {
	label: string;
	testId?: string;
}

export const FlagDisabledBaseIcon = ({ label, testId }: FlagIconProps) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={label || undefined}
		role={label ? 'img' : 'presentation'}
		data-testid={testId}
	>
		<rect width="24" height="24" fill="white" fill-opacity="0.01" />
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M17.7065 2.70708C18.097 3.0976 18.097 3.73077 17.7065 4.12129L17.3155 4.51232C17.3156 4.51234 17.3156 4.51237 17.3157 4.51239L14.8957 6.93245C14.8956 6.93245 14.8955 6.93245 14.8954 6.93245L10.884 10.9438C10.884 10.9439 10.8841 10.9439 10.8842 10.9439L9.07624 12.7519C9.07613 12.7519 9.07602 12.7519 9.07591 12.7519L7.99956 13.8282V13.8286L5.99956 15.8286V15.8282L4.97859 16.8492C4.58807 17.2397 3.9549 17.2397 3.56438 16.8492C3.17385 16.4587 3.17385 15.8255 3.56438 15.435L5.99956 12.9998V12.235V5.46601C5.99955 5.27855 6.05224 5.09486 6.15161 4.93591C6.25098 4.77695 6.39303 4.64912 6.56156 4.56701C8.55256 3.60001 10.5106 4.07501 12.2396 4.49501L12.2439 4.49608C12.9003 4.65524 13.5206 4.80568 14.1169 4.88244L16.2923 2.70708C16.6828 2.31655 17.316 2.31655 17.7065 2.70708ZM5.99956 17.9652V18.681C5.99956 19.218 6.44956 19.658 6.99956 19.658C7.54956 19.658 7.99956 19.218 7.99956 18.681V15.9652L5.99956 17.9652ZM10.9624 13.0024C11.225 13.0612 11.4931 13.1263 11.7676 13.193L11.7846 13.1971L11.7846 13.1971C12.7617 13.434 13.8099 13.688 14.8976 13.688C15.7789 13.6974 16.6505 13.5034 17.4446 13.121C17.6134 13.039 17.7558 12.9111 17.8553 12.7519C17.9549 12.5927 18.0077 12.4088 18.0076 12.221V5.95723L16.0076 7.95723V11.539C14.9487 11.8482 13.8479 11.6346 12.6224 11.3424L10.9624 13.0024ZM11.7676 6.43801C11.9779 6.48907 12.1916 6.54096 12.4084 6.59097L8.1764 10.823C8.11733 10.8318 8.05838 10.8415 7.99956 10.852V6.14801C9.16794 5.80649 10.3852 6.10219 11.7618 6.43662L11.7676 6.43801Z"
			fill="#C1C7D0"
		/>
	</svg>
);

export const FlagEnabledBaseIcon = ({ label, testId }: FlagIconProps) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={label || undefined}
		role={label ? 'img' : 'presentation'}
		data-testid={testId}
	>
		<rect width="24" height="24" fill="white" fill-opacity="0.01" />
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M6 12.235V18.681C6 19.218 6.45 19.658 7 19.658C7.55 19.658 8 19.218 8 18.681V12.903C9.17 12.562 10.389 12.858 11.768 13.193C12.75 13.431 13.804 13.688 14.898 13.688C15.7793 13.6974 16.6509 13.5034 17.445 13.121C17.6139 13.039 17.7562 12.9111 17.8558 12.7519C17.9554 12.5927 18.0081 12.4088 18.008 12.221V5.46601C18.0086 5.29627 17.966 5.12918 17.884 4.98052C17.8021 4.83186 17.6836 4.70656 17.5397 4.61647C17.3959 4.52637 17.2314 4.47445 17.0619 4.46562C16.8924 4.45679 16.7234 4.49135 16.571 4.56601C15.226 5.22001 13.84 4.88301 12.24 4.49501C10.511 4.07501 8.553 3.60001 6.562 4.56701C6.39348 4.64912 6.25143 4.77695 6.15205 4.93591C6.05268 5.09486 6 5.27855 6 5.46601V12.235ZM9.111 10.755C10.205 10.755 11.259 11.011 12.24 11.25C13.621 11.585 14.84 11.88 16.008 11.539V6.83601C14.52 7.10601 13.078 6.75601 11.768 6.43801C10.389 6.10301 9.17 5.80601 8 6.14801V10.852C8.36666 10.7863 8.7385 10.7539 9.111 10.755Z"
			fill="#42526E"
		/>
	</svg>
);

const FlagDisabledGlyph = () => <img src={flagDisabledIconUrl} alt="" />;

export const FlagDisabledIcon = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return fg('enghealth-custom-icon-migration') ? (
		<FlagDisabledBaseIcon
			label={formatMessage(messages.flagEnabledIconLabel)}
			testId="software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.icons.disabled"
		/>
	) : (
		// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
		<Icon
			testId="software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.icons.disabled"
			size="medium"
			glyph={FlagDisabledGlyph}
			label={formatMessage(messages.flagDisabledIconLabel)}
		/>
	);
};

const FlagEnabledGlyph = () => <img src={flagEnabledIconUrl} alt="" />;

export const FlagEnabledIcon = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return fg('enghealth-custom-icon-migration') ? (
		<FlagEnabledBaseIcon
			label={formatMessage(messages.flagEnabledIconLabel)}
			testId="software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.icons.enabled"
		/>
	) : (
		// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
		<Icon
			testId="software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.icons.enabled"
			size="medium"
			glyph={FlagEnabledGlyph}
			label={formatMessage(messages.flagEnabledIconLabel)}
		/>
	);
};
